import { css } from '@emotion/react'

import Colours from '@thebeansgroup/ui_style_helpers/colours'

import { WITHOUT_SUBLABEL_SPACING, WITH_SUBLABEL_SPACING } from './constants'

export const placeholder = (subLabel) => css`
  padding: 0 12px;
  position: absolute;
  top: ${subLabel ? WITH_SUBLABEL_SPACING : WITHOUT_SUBLABEL_SPACING};
  font-size: 16px;
  line-height: 16px;
  color: ${Colours('liquorice', '200')};
  pointer-events: none;
`
